<template>
    <v-layout column class="pa-4">
        <v-breadcrumbs class="pl-0">
            <v-icon #divider>keyboard_arrow_left</v-icon>
            <router-link to="/">
                <v-breadcrumbs-item>
                    <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                </v-breadcrumbs-item>
            </router-link>
            <router-link to="/knowledge_check">
                <v-breadcrumbs-item>
                    <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{ $t("Проверка знаний") }}
                </v-breadcrumbs-item>
            </router-link>
        </v-breadcrumbs>
        <h1 class="section-title-main my-3 font-weight-regular">
            {{ get_selected_course.name }}
        </h1>
        <v-layout row wrap :column="$vuetify.breakpoint.smAndDown">
            <labelTopic :class="[classes, {'mr-0': $vuetify.breakpoint.xs, 'mr-3': $vuetify.breakpoint.smAndUp}]">
                {{ $t(currentStatusText) }}
            </labelTopic>
            <v-layout class="mt-2" :class="{'mt-3 ml-0': $vuetify.breakpoint.smAndDown, 'ml-4': $vuetify.breakpoint.xl}">
                <svg v-svg
                     symbol="schedule"
                     class="knowledge-check__icon knowledge-check__icon-grey mr-0"
                     role="presentation"
                />
                <v-flex xs11 sm10 md11
                        ml-2
                >{{ get_selected_course.appointmentPeriod }}</v-flex>
            </v-layout>
        </v-layout>
        <v-layout row wrap :class="{'mt-5': $vuetify.breakpoint.mdAndUp, 'mb-5': $vuetify.breakpoint.smAndUp}">
            <v-flex :class="{'course-aside': $vuetify.breakpoint.mdAndUp}" class="wrapper-relative md3">
                <div class="course-aside__wrapper js-course-sidebar" :class="{'pr-4': $vuetify.breakpoint.mdAndUp}">
                    <v-layout row align-center mb-4>
                        <v-flex lg5 md4 sm2
                                xs5 justify-end
                                class="mr-3"
                        >
                            <span>
                                {{ $t("Результат итогового теста") }}
                            </span>
                            {{ get_selected_course.correctAnswers || 0 }} {{ $t("из") }} {{ get_selected_course.totalQuestions || 0 }}
                        </v-flex>
                        <v-flex md3 lg3 xs4
                                mr-2
                        >
                            <v-progress-circular
                                :rotate="-90"
                                :size="64"
                                :width="6"
                                :value="get_selected_course.completionPercent || 0"
                                :class="get_selected_course.completionPercent === 100 ? 'green-text' : 'red-text'"
                            >
                                {{ get_selected_course.completionPercent || 0 }}%
                            </v-progress-circular>
                        </v-flex>
                    </v-layout>
                    <div v-if="get_selected_course.status !== COURSE_TYPES.COMPLETE"
                         class="mt-4 mb-3 text-uppercase"
                    >
                        <svg v-svg
                             symbol="hourglass"
                             size="93 88"
                             class="knowledge-check__icon knowledge-check__icon-grey mr-2"
                             role="presentation"
                        />
                        <span class="text-uppercase">{{ show_rest_time }}</span>
                    </div>
                    <v-layout
                        v-if="get_selected_course.status === COURSE_TYPES.COMPLETE"
                        class="mt-4 mb-3"
                    >
                        <v-layout v-if="get_selected_course.completionDate" class="green-tex">
                            <svg v-svg
                                 symbol="completed"
                                 size="16"
                                 class="knowledge-check__icon mr-2 green-text"
                                 role="presentation"
                            />
                            <v-flex class="text-uppercase green-text">
                                {{ $t("тест успешно сдан") }}: {{ get_selected_course.completionDate }}
                            </v-flex>
                        </v-layout>
                        <v-flex v-else class="text-uppercase red-text">
                            {{ $t("тест не сдан") }}
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex :class="{'pl-5': $vuetify.breakpoint.mdAndUp}" class="js-test-content md9">
                <KnowledgeCheckQuestions :questions="question_list" :current_question="get_current_question" />
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
import labelTopic from '@/components/ui/labels/label_topic.vue';
import {mapGetters, mapActions, mapMutations} from 'vuex';
import {COURSE_TYPES} from '@/modules/Knowledge_check/Knowledge_check';
import KnowledgeCheckQuestions from '@/components/view_blocks/Knowledge_check_detail/Knowledge_check_questions.vue';
import {getDeclension} from '@/lib/helpers';

export default {
  name      : 'KnowledgeCheckDetailWrap',
  components: {KnowledgeCheckQuestions, labelTopic},
  data() {
    return {
      course: {},
      COURSE_TYPES,
    };
  },
  computed: {
    ...mapGetters('knowledge_check', ['selected_filter', 'get_selected_course', 'filters']),
    ...mapGetters('knowledge_check/knowledge_check_test', ['question_list', 'get_current_question']),
    currentStatusText() {
      if (!this.filters || !this.get_selected_course.status) {
        return '';
      }
      const filter = this.filters.find(
          (filter) => filter.name === this.get_selected_course.status
      );
      return filter ? filter.label_text : 'Просрочен';
    },
    classes() {
      const obj = {
        [COURSE_TYPES.NEW]     : 'section-label--green',
        [COURSE_TYPES.COMPLETE]: 'section-label--grey',
        [COURSE_TYPES.ACTIVE]  : 'section-label--light-grey',
      };

      return obj[this.get_selected_course.status];
    },
    show_rest_time() {
      if (this.get_selected_course.daysUntilExpire === 0) {
        return 'Просрочен';
      } else {
        return `${getDeclension(this.get_selected_course.daysUntilExpire, 'Остался', 'Осталось', 'Осталось')} ${this.get_selected_course.daysUntilExpire} ${getDeclension(this.get_selected_course.daysUntilExpire, 'день', 'дня', 'дней')}`;
      }
    },
  },
  async mounted() {
    await Promise.all([
      this.get_course_by_id(this.$route.params.id),
      this.get_course_questions(this.$route.params.id),
    ]);
    this.SET_COURSE_ID_AT_ANSWERS(this.get_selected_course.id);
  },
  destroyed() {
    this.CLEAR_ANSWERS();
  },
  methods: {
    ...mapActions('knowledge_check', ['get_course_by_id']),
    ...mapActions('knowledge_check/knowledge_check_test', ['get_course_questions']),
    ...mapMutations('knowledge_check/knowledge_check_test', ['SET_COURSE_ID_AT_ANSWERS', 'CLEAR_ANSWERS']),
  },
};
</script>
